// extracted by mini-css-extract-plugin
module.exports = {"input-adornment":"a2c79c7e7d--input-adornment--KR8eN"};